import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/spoon.png'
import _imports_1 from '@/assets/images/illustrations/warning.png'


const _hoisted_1 = { class: "_modal bg-white" }
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "Luca Education",
  title: "Luca Education",
  height: "60",
  width: "60"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: "Luca Education",
  title: "Luca Education",
  height: "60",
  width: "60"
}
const _hoisted_5 = { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5" }
const _hoisted_6 = { class: "text-center text-neutral-500 mt-2" }
const _hoisted_7 = {
  key: 0,
  class: "w-full"
}
const _hoisted_8 = { class: "p-6 bg-white select-tabs" }
const _hoisted_9 = { class: "flex flex-nowrap items-center" }
const _hoisted_10 = { class: "flex flex-nowrap items-center font-medium" }
const _hoisted_11 = {
  key: 1,
  class: "w-full flex items-center justify-center mb-8"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "button-p btn--ghost w-fit"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 whitespace-nowrap" }, "Tạo lớp bán trú")
], -1)
const _hoisted_13 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (_ctx.classes.length > 0)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : (_openBlock(), _createElementBlock("img", _hoisted_4))
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.classes.length > 0
						? 'Thay đổi lớp bán trú'
						: 'Chưa có lớp bán trú nào'), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.classes.length > 0
						? `Bạn hãy chọn lớp bán trú từ danh sách lớp bán trú của cơ sở`
						: `Cơ sở của bạn chưa có lớp bán trú nào`), 1)
    ]),
    (_ctx.classes.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.classSelected,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.classSelected) = $event)),
              "deselect-label": "Đã chọn",
              "track-by": "id",
              options: 
						_ctx.classes?.map((s) => {
							return {
								nameSearch: _ctx.toEnglish(s?.name),
								...s,
							};
						})
					,
              searchable: true,
              label: "nameSearch",
              "allow-empty": false,
              selectLabel: "",
              placeholder: "Chọn lớp bán trú",
              maxHeight: 100
            }, {
              noResult: _withCtx(() => [
                _createTextVNode(" Không tìm thấy kết quả ")
              ]),
              option: _withCtx((props) => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, _toDisplayString(props.option.name), 1)
                ])
              ]),
              singleLabel: _withCtx(({ option }) => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, _toDisplayString(option.name), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_router_link, { to: "/daycare-class" }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, " Đóng "),
      (_ctx.classes.length > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "button-p text-center whitespace-nowrap",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          }, " Xác nhận "))
        : _createCommentVNode("", true)
    ])
  ]))
}